import { IsLoginType } from 'typings/login'
import { create } from 'zustand'

export const useIsLoginStore = create<IsLoginType>()(set => ({
    isLogin: true,
    setIsLogin: (value: boolean) => set({ isLogin: value }),
}))
